// extracted by mini-css-extract-plugin
export default {"layout":"details-step_layout__rsxkz","toggleCardChildren":"details-step_toggleCardChildren__xN0lu","detailsHeader":"details-step_detailsHeader__gf5Un"};